<template>
  <div class="md-layout card-relatorio">
    <div class="md-layout-item md-size-50 md-medium-size-45 md-small-size-100 md-xsmall-size-100">
      <div class="flex no-flex-xs">
        <md-field>
          <label>Enviar por e-mail</label>
          <md-input v-model="emails_lista" id="txt_emails_lista"></md-input>
          <span class="md-helper-text">Separe por vírgula os e-mails</span>
        </md-field>
        <md-button class="md-success" type="button" v-on:click="enviar_email">
          <md-icon>send</md-icon>Enviar por e-mail
        </md-button>
      </div>
    </div>

    <div class="md-layout-item md-size-50 md-medium-size-55 md-small-size-100 md-xsmall-size-100">
      <div class="flex-end group-btn-right" v-if="item.urls != null && item.urls != undefined">
        <a v-bind:href="item.urls.print" target="_blank" style="color: white">
          <md-button type="button" class="md-primary">
            <md-icon>local_printshop</md-icon>Imprimir
          </md-button>
        </a>
        <a v-bind:href="item.urls.pdf" target="_blank" style="color: white">
          <md-button type="button" class="md-info">
            <md-icon>picture_as_pdf</md-icon>Exportar PDF
          </md-button>
        </a>
        <a
          v-if="grafico=='1' && item.urls.grafico != null && onGrafico != null"
          v-on:click="onGrafico(item, tipo)"
          target="_blank"
          style="color: white"
        >
          <md-button type="button" class="md-default">
            <md-icon>bar_chart</md-icon>Gráfico
          </md-button>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../library/Util";
import swal from "sweetalert2";
import ApiJquery from "../../../library/ApiJquery";

export default {
  components: {},

  props: {
    item: {
      default: { emails_lista: "" },
      type: Object
    },
    tipo: {
      default: "inspecao",
      type: String
    },
    grafico: {
      default: "0",
      type: String
    },
    onGrafico: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      emails_lista: ""
    };
  },
  mounted() {
    if (this.item != null && this.item.urls.email != null) {
      this.emails_lista = this.item.urls.email;
    }
  },
  methods: {
    open(url) {
      window.open(url);
    },
    enviar_email() {
      if (this.emails_lista.trim() == "") {
        Util.alerta(swal, "Atenção", "Informe ao menos um email", null);
        $("#txt_emails_lista").focus();
        return false;
      }

      // t

      var data = {
        url_envia: this.item.urls.print,
        t: this.tipo,
        emails_lista: this.emails_lista
      };
      var self = this;
      ApiJquery.callJquery(this.item.urls.send, "POST", data, function(res) {
        // var obj = JSON.parse(res);
        console.log(self.item.urls.send);
        var msg = res;

        if (res.indexOf("sucesso") > -1) {
          msg = "Email enviado com sucesso!";
        }
        Util.alerta(swal, "Sucesso!", msg, null);
      });

      ////url_envia  emails_lista
    }
  }
};
</script>